import { Image, Input } from "@/components/ui";
import { View } from "@/components/ui/view";
import LogoIcon from "@/assets/images/logo-icon.png";
import { IconButton } from "@/components/ui/icon-button";
import { cn } from "@/lib/utils";

const defaultInputClassName =
  "!h-10 flex-1 rounded-full border-0 py-0 pl-10 pr-2 text-[12px]";

type SearchInputProps = Omit<
  React.ComponentProps<typeof Input>,
  "onChange" | "onChangeText"
> & {
  onChange?: (value: string) => void;
  onClick?: () => void;
  className?: string;
};

export const SearchInput = ({
  onChange,
  onClick,
  className,
  ...props
}: SearchInputProps) => {
  return (
    <View
      onClick={onClick}
      className={cn(
        "relative flex flex-row items-center gap-1 rounded-full border border-border bg-white px-2",
        onClick && "cursor-pointer",
      )}
    >
      <View className="absolute left-0 z-50 flex h-10 w-10 items-center justify-center">
        <Image src={LogoIcon} width={16} height={16} />
      </View>
      <Input
        placeholder="Search for Services"
        className={cn(defaultInputClassName, className)}
        onChangeText={onChange}
        {...props}
      />
      <View className="absolute right-0 z-50 flex h-10 w-12 items-center justify-center">
        <IconButton
          className="h-8 w-10 rounded-full border-0 bg-brand-primary"
          variant="primary"
          color="CTA2"
          size="sm"
          iconName="magnifyingGlass"
        />
      </View>
    </View>
  );
};
